import { Link } from "react-router-dom";
import { Mic } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useGame } from "@/components/game/useGame";
import { WeekStanding, SeasonStanding } from "@/components/game/Standings";
import { StreakChip } from "@/components/game/PersonalGame";
import { ChallengeNotices, ChallengePanel } from "@/components/game/Challenges";
import { PastWeeks } from "@/components/game/PastWeeks";
import { PastQuarters } from "@/components/game/PastQuarters";

export default function GamePage() {
  const { user } = useAuth();
  const game = useGame(user);
  return <div className="max-w-4xl mx-auto px-5 sm:px-8 py-8 sm:py-12" data-testid="game-page">
    <p className="font-mono text-xs uppercase tracking-widest text-tw-yellow mb-2">Samen de week winnen</p>
    <h1 className="font-display text-4xl sm:text-5xl font-black mb-6">De week is <span className="text-tw-yellow">van ons.</span></h1>
    {game.isStarter ? <Link to="/" className="game-primary" data-testid="game-page-starter"><Mic size={16} />Begin met één vraag</Link> : <>
      <StreakChip streak={game.streak} prefix="game-page-streak" />
      {game.showStanding && <div className={game.season?.season ? "game-layout" : ""}><WeekStanding week={game.week} prefix="game-page-week" /><SeasonStanding data={game.season} prefix="game-page-season" /></div>}
      {game.showStanding && <PastWeeks prefix="game-page-past-weeks" />}
      {game.showStanding && <PastQuarters prefix="game-page-past-quarters" />}
      <ChallengeNotices data={game.challenges} user={user} reload={game.reload} prefix="game-page-challenges" />
      {game.showStanding && <ChallengePanel game={game} user={user} prefix="game-page-challenge-panel" />}
    </>}
  </div>;
}